import { render } from "./ResumeComponents.vue?vue&type=template&id=a91cc648"
import script from "./ResumeComponents.vue?vue&type=script&lang=js"
export * from "./ResumeComponents.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dhaffaabdillah/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__